import React, { useState } from 'react';

const FGTS = () => {
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');
    const [salarioBruto, setSalarioBruto] = useState('');
    const [resultado, setResultado] = useState(null);

    const calcularFGTS = () => {
        // Validação de entradas
        if (!dataInicial || !dataFinal || !salarioBruto) {
            alert('Por favor, preencha todos os campos.');
            return;
        }

        // Converte o salário bruto para número
        const salarioBrutoNum = parseFloat(salarioBruto);
        if (isNaN(salarioBrutoNum)) {
            alert('Por favor, insira um valor válido para o salário bruto.');
            return;
        }

        const inicio = new Date(dataInicial);
        const fim = new Date(dataFinal);

        // Diferença entre as datas em meses
        const diffEmMilissegundos = fim - inicio;
        const diffEmMeses = Math.ceil(diffEmMilissegundos / (1000 * 60 * 60 * 24 * 30));

        if (diffEmMeses <= 0) {
            alert('A data final deve ser posterior à data inicial.');
            return;
        }

        // O valor do FGTS é de 8% do salário bruto mensal
        const fgtsMensal = salarioBrutoNum * 0.08;
        const fgtsTotal = fgtsMensal * diffEmMeses;

        // Simulação de correção de juros (exemplo de 0.25% ao mês)
        const taxaJuros = 0.0025;
        const juros = fgtsTotal * taxaJuros * diffEmMeses;

        // Calcular o saldo corrigido com juros
        const saldoCorrigido = fgtsTotal + juros;

        // Calcular multa de 40%
        const multa40 = saldoCorrigido * 0.40;

        // Calcular total com multa
        const totalComMulta = saldoCorrigido + multa40;

        // Formatação dos valores
        const formatarValor = (valor) => `R$ ${valor.toFixed(2).replace('.', ',')}`;

        // Atualizar o resultado com todas as informações
        setResultado({
            dataInicial: inicio.toLocaleDateString(),
            dataFinal: fim.toLocaleDateString(),
            mesesTrabalhados: diffEmMeses,
            salarioBase: formatarValor(salarioBrutoNum),
            fgtsMensal: formatarValor(fgtsMensal),
            fgtsTotal: formatarValor(fgtsTotal),
            juros: formatarValor(juros),
            saldoCorrigido: formatarValor(saldoCorrigido),
            multa40: formatarValor(multa40),
            totalComMulta: formatarValor(totalComMulta),
        });
    };

    const limparCampos = () => {
        setDataInicial('');
        setDataFinal('');
        setSalarioBruto('');
        setResultado(null);
    };

    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Saldo FGTS</h1>
            </div>
            <div className='label-calculo'>
                <h3 className='txt-calculo'>Data Inicial:</h3>
                <input
                    className='input-calculo'
                    type='date'
                    value={dataInicial}
                    onChange={(e) => setDataInicial(e.target.value)}
                />
            </div>
            <div className='label-calculo'>
                <h3 className='txt-calculo'>Data Final:</h3>
                <input
                    className='input-calculo'
                    type='date'
                    value={dataFinal}
                    onChange={(e) => setDataFinal(e.target.value)}
                />
            </div>
            <div className='label-calculo'>
                <h3 className='txt-calculo'>Salário Bruto:</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={salarioBruto}
                    onChange={(e) => setSalarioBruto(e.target.value)}
                />
            </div>

            <div className="btn-container">
                <button className='btn-calculo-limpar' onClick={limparCampos}>
                    Limpar
                </button>
                <button className='btn-calculo' onClick={calcularFGTS}>
                    Calcular
                </button>

            </div>

            {resultado && (<hr className='hr-separador'></hr>)}

            {resultado && (
                <div className='resultado-calculo'>
                    <h3 className='titulo-resultado'>Resultado do Cálculo do FGTS</h3>
                    <p className='txt-resultado'>Início: {resultado.dataInicial}</p>
                    <p className='txt-resultado'>Final: {resultado.dataFinal}</p>
                    <p className='txt-resultado'>Meses trabalhados: {resultado.mesesTrabalhados}</p>
                    <p className='txt-resultado'>Salário base: {resultado.salarioBase}</p>
                    <p className='txt-resultado'>Depósito FGTS/mês (8%): {resultado.fgtsMensal}</p>
                    <hr className='hr-resultado'/>
                    <p className='txt-resultado'>Saldo FGTS: {resultado.fgtsTotal}</p>
                    <p className='txt-resultado'>Juros: {resultado.juros}</p>
                    <p className='txt-resultado'>Saldo FGTS Corrigido: {resultado.saldoCorrigido}</p>
                    <p className='txt-resultado'>Multa 40%: {resultado.multa40}</p>
                    <p className='txt-resultado'>Total FGTS com 40% de multa em caso de demissão: {resultado.totalComMulta}</p>
                </div>
            )}
        </div>
    );
};

export default FGTS;
